import React from 'react';
import Sidebar from '../../components/Super Admin/SideBar/Sidebar';
import Tabs from '../../components/Super Admin/TopBar/TopbarPayments';
import FeeTaxConfig from '../../components/Super Admin/Payment/FeeTaxConfig';
import '../../css/FeeConfigPage.css';

const FeeConfigPage: React.FC = () => {
  return (
    <>
        <Tabs activeTab="fee" />
        <FeeTaxConfig />
    </>
  );
};

export default FeeConfigPage;
